export default {
  mails(state) {
    if (state.mails.lenght <= 0) {
      state.mails = JSON.parse(localStorage.getItem("mails")) || [];
    }
    return state.mails || [];
  },

  sentMails(state) {
    if (state.sentMails.lenght <= 0) {
      state.sentMails = JSON.parse(localStorage.getItem("sentMails")) || [];
    }
    return state.sentMails || [];
  },
};
